import { AxiosPromise } from 'axios'
import { EsimReplacement } from 'types/api/faber/subscription.type'

import FaberApi from '.'

class ReplacementAPI {
  /**
   * @returns
   */
  static esimReplacement(body: {
    userId: string
    remarks: string
    faberToken: string
  }): AxiosPromise<EsimReplacement> {
    return FaberApi.httpPost(
      `/esim/replacement`,
      { Authorization: `Bearer ${body.faberToken}` },
      body
    )
  }

  static esimOTPReplacement(body: {
    userId: string
    remarks: string
    faberToken: string
  }): AxiosPromise<EsimReplacement> {
    return FaberApi.httpPost(
      `/sim/ops/esim/replace/onetimepack`,
      { Authorization: `Bearer ${body.faberToken}` },
      body
    )
  }
}

export default ReplacementAPI
